import { Injectable, OnInit } from '@angular/core';
import {
  AngularFireDatabase,
  AngularFireList,
} from '@angular/fire/compat/database';
import { Observable, filter, interval, switchMap } from 'rxjs';
import { UserLocationPermissionDialogComponent } from '../common/modules/dialog-pop-ups/components/user-location-permission-dialog/user-location-permission-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Geolocation } from '@capacitor/geolocation';
import { Capacitor, registerPlugin } from '@capacitor/core';
import { BackgroundGeolocationPlugin } from '@capacitor-community/background-geolocation';
import { IRespond } from '../models/requests';
import { UserRegDetails } from '../models/user';
import {
  EncryptionService,
  UserDetailsToken,
} from './Encryption/encryption.service';
const BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>(
  'BackgroundGeolocation'
);

@Injectable({
  providedIn: 'root',
})
export class AumyeEmergencyLocationService implements OnInit {
  // This code is written by SACHIN RAJ
  orgId: string = null;
  userId: string = null;
  fullName: string = null;
  role: string = null;
  profilePic = localStorage.getItem('ProfilePic');
  userEmail: string = null;
  isLocationAccess = false;
  loggedInUser: OrgActiveUser;
  activeUsers$: Observable<any[]>;
  activeRequests$: Observable<any[]>;
  index = 0;
  activeUsers: string = `Aumye/Emergency/Organization/${this.orgId}/ActiveUsers/`;
  orgRequests: string = `Aumye/Emergency/Organization/${this.orgId}/Requests/`;
  firebaseOrgUrl: string = `Aumye/Emergency/Organization/${this.orgId}/ActiveUsers/${this.userId}`;
  firebaseUserLocationUrl = `${this.firebaseOrgUrl}/ActiveUsers/${this.userId}/LoggedUserData/userCurrentLocation`;
  activeUsersRef: AngularFireList<any> = this.db.list(this.activeUsers);
  isInitiated = false;
  period: number = 10000;
  loggedUser: UserDetailsToken;

  constructor(
    private db: AngularFireDatabase,
    private dialog: MatDialog,
    private encryptionService: EncryptionService
  ) {}
  ngOnInit(): void {
    this.loggedUser = this.encryptionService.getCurrentUser();
    this.orgId = this.loggedUser.organizationID;
    this.userId = this.loggedUser.userID;
    this.fullName = this.loggedUser.fullName;
    this.role = this.loggedUser.role;
    this.profilePic = localStorage.getItem('ProfilePic');
    this.userEmail = this.loggedUser.email;
    this.isLocationAccess = this.loggedUser.isLocationAccess;
  }
  initLocationService() {
    if (this.loggedUser == null) {
      this.loggedUser = this.encryptionService.getCurrentUser();
    }
    this.orgId = this.loggedUser.organizationID;
    this.userId = this.loggedUser.userID;
    this.fullName = this.loggedUser.fullName;
    this.role = this.loggedUser.role;
    this.profilePic = localStorage.getItem('ProfilePic');
    this.userEmail = this.loggedUser.email;
    this.isLocationAccess = this.loggedUser.isLocationAccess;
    this.firebaseOrgUrl = `Aumye/Emergency/Organization/${this.orgId}/ActiveUsers/${this.userId}`;
    this.activeUsers = `Aumye/Emergency/Organization/${this.orgId}/ActiveUsers/`;
    this.activeUsers$ = this.db.list(this.firebaseOrgUrl).valueChanges();
    this.activeUsersRef = this.db.list(this.activeUsers);
    this.isInitiated = true;
  }

  async updateLocation(period: number): Promise<void> {
    this.period = period;
    if (!this.isInitiated) await this.initLocationService();
    const platform = Capacitor.getPlatform();

    const locationInterval$ = interval(this.period).pipe(
      filter((isLocationAccess) => this.isLocationAccess),
      switchMap(() => {
        return this.getCurrentLocation(); // for new app without background location
        // if (platform === 'web') {
        //   return this.getCurrentLocation();
        // } 
        // else {
        //   return this.getBackgroundCurrentLocation();
        // }
      })
    );

    // Update location to Firebase
    locationInterval$.subscribe((location) => {
      if (location) {
        this.db.database
          .ref(`Aumye/Emergency/Organization/${this.orgId}`)
          .child('ActiveUsers')
          .child(this.userId)
          .once('value')
          .then((snapshot) => {
            if (snapshot.exists()) {
              this.db.database
                .ref(`${this.firebaseOrgUrl}/LoggedUserData/`)
                .update({
                  index: this.index++,
                  userName: this.fullName,
                  role: this.role,
                  profilePic: this.profilePic,
                  userEmail: this.userEmail,
                  userId: this.userId,
                  lastUpdated: new Date(),
                  userCurrentLocation: {
                    latitude: location.latitude,
                    longitude: location.longitude,
                  },
                  platform: platform,
                });
            } else {
              this.loggedInUser = {
                userName: this.fullName,
                userCurrentLocation: {
                  latitude: location.latitude,
                  longitude: location.longitude,
                },
                index: this.index++,
                lastUpdated: new Date(),
                role: this.role,
                profilePic: this.profilePic,
                userEmail: this.userEmail,
                userId: this.userId,
                platform: platform,
              };
              this.db.database.ref(`${this.firebaseOrgUrl}`).update({
                LoggedUserData: this.loggedInUser,
              });
            }
          })
          .catch((error) =>
            console.error('Error checking user existence:', error)
          );
      }
    });
  }
  updateStaticLocation(lng: number, lat: number, respond: UserRegDetails) {
    const platform = 'web';
    let loggedInUser: OrgActiveUser;
    let firebaseOrgUrl: string = `Aumye/Emergency/Organization/${this.orgId}/ActiveUsers/${respond.userId}`;
    if (location) {
      this.db.database
        .ref(`Aumye/Emergency/Organization/${this.orgId}`)
        .child('ActiveUsers')
        .child(respond.userId)
        .once('value')
        .then((snapshot) => {
          if (snapshot.exists()) {
            this.db.database.ref(`${firebaseOrgUrl}/LoggedUserData/`).update({
              index: 1,
              userName: respond.firstname + ' ' + respond.lastname,
              role: respond.userRole,
              profilePic: respond.profilePicture,
              userEmail: respond.email,
              userId: respond.userId,
              lastUpdated: new Date(),
              userCurrentLocation: {
                latitude: lat,
                longitude: lng,
              },
              platform: platform,
            });
          } else {
            loggedInUser = {
              userName: respond.firstname + ' ' + respond.lastname,
              userCurrentLocation: {
                latitude: lat,
                longitude: lng,
              },
              index: 2,
              lastUpdated: new Date(),
              role: respond.userRole,
              profilePic: respond.profilePicture,
              userEmail: respond.email,
              userId: respond.userId,
              platform: platform,
            };
            this.db.database.ref(`${firebaseOrgUrl}`).update({
              LoggedUserData: loggedInUser,
            });
          }
        })
        .catch((error) =>
          console.error('Error checking user existence:', error)
        );
    }
  }
  updateResponderStaticLocation(lat: number, lng: number, respond: any) {
    const platform = 'web';
    let loggedInUser: OrgActiveUser;
    let firebaseOrgUrl: string = `Aumye/Emergency/Organization/${this.orgId}/ActiveUsers/${respond.userId}`;
    if (location) {
      this.db.database
        .ref(`Aumye/Emergency/Organization/${this.orgId}`)
        .child('ActiveUsers')
        .child(respond.userId)
        .once('value')
        .then((snapshot) => {
          if (snapshot.exists()) {
            this.db.database.ref(`${firebaseOrgUrl}/LoggedUserData/`).update({
              index: 1,
              userName: respond.userName,
              role: respond.role,
              profilePic: respond.profilePic,
              userEmail: respond.userEmail,
              userId: respond.userId,
              lastUpdated: new Date(),
              userCurrentLocation: {
                latitude: lat,
                longitude: lng,
              },
              platform: platform,
            });
          } else {
            loggedInUser = {
              userName: respond.userName,
              userCurrentLocation: {
                latitude: lat,
                longitude: lng,
              },
              index: 2,
              lastUpdated: new Date(),
              role: respond.role,
              profilePic: respond.profilePic,
              userEmail: respond.userEmail,
              userId: respond.userId,
              platform: platform,
            };
            this.db.database.ref(`${firebaseOrgUrl}`).update({
              LoggedUserData: loggedInUser,
            });
          }
        })
        .catch((error) =>
          console.error('Error checking user existence:', error)
        );
    }
  }
  getCurrentLocation(): Observable<GeolocationCoordinates | null> {
    return new Observable((observer) => {
      try {
        const permissions = Geolocation.checkPermissions();
      } catch (error) {
        console.error('Error checking location permissions:', error);
      }
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then((permissionStatus) => {
            if (permissionStatus.state === 'granted') {
              navigator.geolocation.getCurrentPosition(
                (position) => observer.next(position.coords),
                (error) => {
                  console.error('Error getting location: 1', error);
                  observer.next(null);
                }
              );
            } else if (permissionStatus.state === 'prompt') {
              // Permission is not yet granted, prompt the user
              navigator.geolocation.getCurrentPosition(
                (position) => observer.next(position.coords),
                (error) => {
                  // this.openSnackBar(error.message, 'Close');
                  console.error('Error getting location: 2', error);

                  observer.next(null);
                }
              );
            } else {
              // Permission is denied or something went wrong
              console.error('Geolocation permission denied');
              observer.next(null);
            }
          })
          .catch((error) => {
            console.error('Error querying permission:', error);
            observer.next(null);
          });
      } else {
        // Fallback to the legacy method if permissions API is not supported
        navigator.geolocation.getCurrentPosition(
          (position) => observer.next(position.coords),
          (error) => {
            console.error('Error getting location: 3', error);
            observer.next(null);
          }
        );
      }
    });
  }
  getBackgroundCurrentLocation(): Observable<any> {
    return new Observable((observer) => {
      BackgroundGeolocation.addWatcher(
        {
          backgroundMessage: 'Cancel to prevent battery drain.',
          backgroundTitle: 'Tracking You.',
          requestPermissions: true,
          stale: false,
          distanceFilter: 5, // Ensures high frequency updates
        },
        (location, error) => {
          if (error) {
            observer.error(error);
            if (error.code === 'NOT_AUTHORIZED') {
              if (
                window.confirm(
                  'This app needs your location, but does not have permission.\n\nOpen settings now?'
                )
              ) {
                BackgroundGeolocation.openSettings();
              }
            }
            return;
          }
          observer.next(location);
        }
      );
    });
  }
  clearFirebaseData() {
    this.db
      .object(`${this.activeUsers}`)
      .remove() // Clears data at the given path
      .then(() => console.log('Firebase data cleared on reload.'))
      .catch((error) => console.error('Error clearing data:c', error));
  }
  fetchActiveUserDetails(): Observable<any[]> {
    this.activeUsers$ = this.activeUsersRef.valueChanges();
    return this.activeUsers$;
  }
  logOutUser() {
    this.db
      .object(`${this.firebaseOrgUrl}`)
      .remove()
      .then(() => {
        console.log(
          `Successfully removed ${this.userId} from ${this.firebaseOrgUrl}`
        );
      })
      .catch((error) => {
        console.error(
          `Error removing ${this.userId} from ${this.firebaseOrgUrl}: ${error.message}`
        );
      });
  }
  autoRemoveInActiveUser() {
    this.activeUsers$.subscribe((data: any) => {
      if (data && data.length > 0) {
        const fiveMinutesInMillis = 15 * 60 * 1000; // 2 hours in milliseconds
        const currentTime = new Date();
        data.forEach((user: any) => {
          if (user) {
            const lastUpdatedTime = new Date(user.lastUpdated);
            const timeDifference =
              currentTime.getTime() - lastUpdatedTime.getTime();
            if (!!timeDifference && timeDifference > fiveMinutesInMillis) {
              this.customLogOutUser(user.userId);
            }
          }
        });
      }
    });
  }
  customLogOutUser(userId: string) {
    const firebaseOrgUserUrl: string = `Aumye/Emergency/Organization/${this.orgId}/ActiveUsers/${userId}`;
    this.db
      .object(`${firebaseOrgUserUrl}`)
      .remove()
      .then(() => {
        console.log(
          `Successfully removed ${userId} from ${this.firebaseOrgUrl}`
        );
      })
      .catch((error) => {
        console.error(
          `Error removing ${userId} from ${this.firebaseOrgUrl}: ${error.message}`
        );
      });
  }
  async addNewRequestToFirebase(requestData: any) {
    const requestId = requestData.requestId;
    const currentLocation = requestData.currentLocation;
    await this.initLocationService();
    this.db.database
      .ref(`Aumye/Emergency/Organization/${this.orgId}`)
      .child('Requests')
      .child(requestId)
      .once('value')
      .then((snapshot) => {
        if (!snapshot.exists()) {
          this.db.database
            .ref(
              `Aumye/Emergency/Organization/${this.orgId}/Requests/${requestId}`
            )
            .update({
              requestId: requestId,
              status: 'Pending',
              userName: this.fullName,
              userRole: this.role,
              userId: this.userId,
              userProfile: this.profilePic,
              userEmail: this.userEmail,
              currentLocation: {
                latitude: currentLocation.latitude,
                longitude: currentLocation.longitude,
              },
              requestRaisedDateTime: new Date(),
            });
        }
      })
      .catch((err) => {
        console.log('ERROR', err);
      });
  }
  fetchOrgRequestDetails(): Observable<any[]> {
    this.activeRequests$ = this.db.list(this.orgRequests).valueChanges();
    return this.activeRequests$;
  }
  isFirstTime = true;
  openSnackBar(message: string, action: string) {
    // this.snackBar.open(message, action, {});
    if (this.isFirstTime) {
      const dialogRef = this.dialog.open(
        UserLocationPermissionDialogComponent,
        {
          width: '250px',
          data: {}, // You can pass any data to the dialog if needed
        }
      );

      dialogRef.afterClosed().subscribe((result) => {
        console.log('The dialog was closed');
      });
      this.isFirstTime = false;
    }
  }
}
export interface OrgActiveUser {
  userName: string;
  userProfile?: string;
  userCurrentLocation: ILocation;
  index?: number;
  lastUpdated: Date;
  role?: string;
  profilePic?: string;
  userEmail?: string;
  userId?: string;
  platform?: string;
}
export interface ILocation {
  latitude: number;
  longitude: number;
}
